import { render, staticRenderFns } from "./StoryboardImageGenerate.vue?vue&type=template&id=620ef71f&scoped=true"
import script from "./StoryboardImageGenerate.vue?vue&type=script&lang=js"
export * from "./StoryboardImageGenerate.vue?vue&type=script&lang=js"
import style0 from "./StoryboardImageGenerate.vue?vue&type=style&index=0&id=620ef71f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ef71f",
  null
  
)

export default component.exports